module.exports = __webpack_public_path__ + "img/kyc.1221c407.svg";